// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function SquareStroked(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "SquareStroked" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.5 5.5H5.5V18.5H18.5V5.5ZM4 4V20H20V4H4Z", fill: "currentColor" }))));
});
//# sourceMappingURL=SquareStroked.js.map